module.exports = __webpack_public_path__ + "static/media/18_10.713b1d4e.png";